export enum TravelAvailability {
    Yes = 1,
    Not = 2,
    Occasionally = 3
}